export default __webpack_public_path__ + "static/media/sgg.41259e45.jpg";